export default "__VITE_ASSET__xShn1KUp__"